import { render, staticRenderFns } from "./statusTag.vue?vue&type=template&id=58d5c765&"
import script from "./statusTag.vue?vue&type=script&lang=js&"
export * from "./statusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d5c765')) {
      api.createRecord('58d5c765', component.options)
    } else {
      api.reload('58d5c765', component.options)
    }
    module.hot.accept("./statusTag.vue?vue&type=template&id=58d5c765&", function () {
      api.rerender('58d5c765', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mvms/components/statusTag.vue"
export default component.exports